import { ReactNode, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

import useExternalStylesheet from 'lib/hooks/useExternalStylesheet';
import { GoogleFonts } from 'lib/interfaces/fonts';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

export const fontImportUrl = (fontFamily?: string, fontUrl?: string): string => {
  if (fontFamily && fontFamily?.replace(/\s/g, '') in GoogleFonts) {
    // NB: For the google fonts we need to replace spaces with '+'s
    const fontFamilyParam = fontFamily.replace(/\s/g, '+');

    // weights correspond to the values permitted from themes / component styles
    return `https://fonts.googleapis.com/css2?family=${fontFamilyParam}:wght@300;400;500;700;900&display=swap`;
  } else if (fontUrl) {
    return fontUrl;
  } else {
    return `https://fonts.googleapis.com/css2?family=${GoogleFonts.Rubik}:wght@300;400;500;700;900&display=swap`;
  }
};

const Container = styled.div`
  font-family: ${({ theme: { fontFamily } }) => fontFamilyCss(fontFamily)};

  color: ${({ theme }) => theme.colorFont};
  font-size: ${({ theme }) => theme.fontSizeBody};
  line-height: ${({ theme }) => theme.lineHeightBody};
`;

const ThemedFonts = ({ children }: { children: ReactNode }) => {
  const { fontFamily, fontFamilyTitle, fontUrl } = useContext(ThemeContext);

  useExternalStylesheet(fontImportUrl(fontFamily, fontUrl));
  useExternalStylesheet(fontImportUrl(fontFamilyTitle, fontUrl));

  return <Container>{children}</Container>;
};

export default ThemedFonts;
